import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import CustomerCard from "./CustomerCard";
import GenderCard from "./GenderCard";
import AgeCard from "./AgeCard";
import LevelChart from "./LevelChart";
import TablePage from "./TablePage";
import Layout from '../../Layout'

export default function Dashboard() {
  const { t } = useTranslation();
    return (
        <Layout>
            <Helmet>
                <title>{t('page.customer_report')} | Khothi</title>
            </Helmet>
            <div className="space-y-4">

                {/* TOP LAYOUT */}
                <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">

                    {/* LEFT */}
                    <div className="xl:col-span-2 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <CustomerCard />
                            <GenderCard />
                        </div>

                        <LevelChart />
                    </div>

                    {/* RIGHT */}
                    <AgeCard />
                </div>

                <TablePage />
            </div>
        </Layout>
    );
}